import './ModalChangePassword.scss'
import React from 'react'
import {withTranslation} from 'react-i18next'
import {withRouter} from '../../../../helpers/withRouter'
import {Button, Divider, Form, Icon, Input, Modal} from 'antd'

class ModalChangePassword extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            passwordCurrent: '',
            passwordNew: '',
            passwordNewConfirm: '',
            confirmDirty: false,
        }
    }

    handlePasswordCurrentOnChange(passwordCurrent) {
        this.setState({passwordCurrent})
    }

    handlePasswordNewOnChange(passwordNew) {
        this.setState({passwordNew})
    }

    handlePasswordNewConfirmOnChange(passwordNewConfirm) {
        this.setState({passwordNewConfirm})
    }

    validateToNextPassword(rule, value, callback) {
        const {confirmDirty} = this.state
        const {validateFields} = this.props.form

        if (value && confirmDirty) {
            validateFields(['password-new-repeat'], {force: true});
        }
        callback();

    };

    compareToFirstPassword(rule, value, callback) {
        const {form, t} = this.props;
        if (value && value !== form.getFieldValue('password-new')) {
            callback(t('messages.aml.errors.pwd.same.validation'));
        } else {
            callback();
        }
    };

    handleConfirmBlur(e) {
        const {value} = e.target;
        const {confirmDirty} = this.state;
        this.setState({confirmDirty: (confirmDirty || !!value)})
    };

    hasErrors(fieldsError) {
        return Object.keys(fieldsError).some((field) => fieldsError[field]);
    }



    render() {
        const {getFieldDecorator, getFieldsError, isFieldsTouched} = this.props.form
        const {visible} = this.props
        const {onOk} = this.props
        const {onCancel} = this.props
        const {isForced} = this.props
        const {isExpiredPassword} = this.props
        const {t} = this.props
        const {recommendedChangePwd} = this.props

        return (
            <Modal
                title={recommendedChangePwd
                    ? [<Icon type="lock" />, ' ', t('messages.aml.changePwd')]
                    : (isForced || isExpiredPassword)
                        ? [<Icon type="exclamation-circle" theme="filled" />, ' ', t('messages.aml.mandatoryAction')]
                        : [<Icon type="lock" />, ' ', t('messages.aml.changePwd')]
                }
                className={((isForced || isExpiredPassword) ? 'forced' : 'normal') + ' modal-change-password'}
                visible={visible}
                footer={[
                    <Button onClick={() => onCancel()}>
                        {t('messages.aml.btnClose')}
                    </Button>
                    ,
                    <Button key="submit"
                            type="primary"
                            onClick={() => onOk(this.state.passwordCurrent, this.state.passwordNew, this.state.passwordNewConfirm)}
                            disabled={
                                this.hasErrors(getFieldsError()) || !isFieldsTouched()
                            }>
                        {t('messages.aml.changePwd')}
                    </Button>
                ]}
                onCancel={onCancel}
                onOk={onOk}
            >
                {recommendedChangePwd ? (<p>{t('messages.aml.recommended.change.pwd')}.</p>) :
                    isExpiredPassword ? (<p>{t('messages.aml.forcedChangeExpiredPassword')}.</p>) :
                        isForced ? (<p>{t('messages.aml.forcedChangePasswordDescription')}.</p>) : null}


                <Form.Item hasFeedback>
                    {getFieldDecorator('password-current', {
                        rules: [
                            {
                                required: true,
                                //message: "Debe ingresar código."
                                message: "Debe ingresar clave."

                            }],
                    })(
                        <Input.Password
                            autoComplete="off"
                            prefix={<Icon type="lock" style={{color: 'rgba(0,0,0,.25)'}}/>}
                            placeholder={t('messages.aml.currentPassword')}
                            onChange={(e) => this.handlePasswordCurrentOnChange.bind(this)(e.target.value)}
                        />
                    )}
                </Form.Item>
                <Divider/>
                <p>{t('messages.aml.newPasswordMustContain')}: <br/><strong>{t('messages.aml.newPasswordInstructions')}</strong>
                </p>
                <div className="new-pass-input-group">

                    <Form.Item hasFeedback>
                        {getFieldDecorator('password-new', {
                            rules: [
                                {
                                    required: true,
                                    message: "Debe ingresar contraseña."
                                },
                                {
                                    validator: (_, value) => {
                                        if (value && (value.length < 8 || value.length > 30)) {
                                            return Promise.reject(new Error(t('messages.aml.errors.pwd.long.validation')));
                                        }
                                        return Promise.resolve();
                                    }
                                },
                                {
                                    validator: (_, value) => {
                                        const allowedChars = /^[a-zA-Z0-9&*?@#!$%\-_]+$/;
                                        const hasUppercase = /[A-Z]/;
                                        const hasLowercase = /[a-z]/;
                                        const hasLetter = /[a-zA-Z]/;
                                        const hasDigit = /[0-9]/;

                                        if (!value) {
                                            return Promise.resolve();
                                        }

                                        if (!hasUppercase.test(value)) {
                                            return Promise.reject(new Error(t('messages.aml.validation.passwordMustHaveUpperCaseLetter')));
                                        }

                                        if (!hasLowercase.test(value)) {
                                            return Promise.reject(new Error(t('messages.aml.validation.passwordMustHaveLowerCaseLetter')));
                                        }

                                        if (!hasDigit.test(value)  || !hasLetter.test(value)) {
                                            return Promise.reject(new Error(t('messages.aml.validation.password.must.be.alphanum')));
                                        }

                                        if (!allowedChars.test(value)) {
                                            return Promise.reject(new Error(t('messages.aml.errors.pwd.special.characters')));
                                        }
                                        return Promise.resolve();
                                    }
                                },
                                {
                                    validator: this.validateToNextPassword.bind(this)
                                },

                            ],
                        })(
                            <Input.Password
                                autoComplete="off"
                                prefix={<Icon type="lock" style={{color: 'rgba(0,0,0,.2)'}}/>}
                                placeholder={t('messages.aml.newPassword')}
                                onChange={(e) => this.handlePasswordNewOnChange.bind(this)(e.target.value)}
                            />,
                        )}
                    </Form.Item>


                    <Form.Item hasFeedback>
                        {getFieldDecorator('password-new-repeat', {
                            rules: [
                                {
                                    required: true,
                                    message: 'Por favor, confirme la nueva contraseña.'
                                },
                                {
                                    validator: (_, value) => {
                                        if (value && (value.length < 8 || value.length > 30)) {
                                            return Promise.reject(new Error(t('messages.aml.errors.pwd.long.validation')));
                                        }
                                        return Promise.resolve();
                                    }
                                },
                                {
                                    validator: (_, value) => {
                                        const allowedChars = /^[a-zA-Z0-9&*?@#!$%\-_]+$/;
                                        const hasUppercase = /[A-Z]/;
                                        const hasLowercase = /[a-z]/;
                                        const hasLetter = /[a-zA-Z]/;
                                        const hasDigit = /[0-9]/;

                                        if (!value) {
                                            return Promise.resolve();
                                        }

                                        if (!hasUppercase.test(value)) {
                                            return Promise.reject(new Error(t('messages.aml.validation.passwordMustHaveUpperCaseLetter')));
                                        }

                                        if (!hasLowercase.test(value)) {
                                            return Promise.reject(new Error(t('messages.aml.validation.passwordMustHaveLowerCaseLetter')));
                                        }

                                        if (!hasDigit.test(value)  || !hasLetter.test(value)) {
                                            return Promise.reject(new Error(t('messages.aml.validation.password.must.be.alphanum')));
                                        }

                                        if (!allowedChars.test(value)) {
                                            return Promise.reject(new Error(t('messages.aml.errors.pwd.special.characters')));
                                        }
                                        return Promise.resolve();
                                    }
                                },
                                {
                                    validator: this.compareToFirstPassword.bind(this),
                                },
                            ]
                        })(
                            <Input.Password
                                autoComplete="off"
                                prefix={<Icon type="lock" style={{color: 'rgba(0,0,0,.25)'}}/>}
                                placeholder={t('messages.aml.newPasswordConfirm')}
                                onChange={(e) => this.handlePasswordNewConfirmOnChange.bind(this)(e.target.value)}
                                onBlur={this.handleConfirmBlur.bind(this)}
                            />
                        )}
                    </Form.Item>
                </div>
            </Modal>
        )
    }
}

const WrappedChangePasswordForm = Form.create({name: 'change_password_form'})(ModalChangePassword)

export default withTranslation()(withRouter(WrappedChangePasswordForm))
